import React, { memo, type ReactNode } from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, type InterpolationValue } from 'styled-components';
import { Flex, xcss } from '@atlaskit/primitives';

import { token } from '@atlaskit/tokens';

import Timestamp from '@atlassian/jira-issue-timestamp/src/main.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';

type Props = {
	date: string;
	text: ReactNode;
	testId?: string;
	focusableTime?: boolean;
};

const MetaDateOld = (props: Props) => {
	const { text, date, testId } = props;
	if (date === undefined || date === null) {
		return null;
	}
	return (
		<Flex testId={testId} xcss={containerStyles}>
			<TextSpan>
				{text}
				&nbsp;
				{/* @ts-expect-error - TS2322 - Type '{ readonly whenDisplaySettingSwitchable: InterpolationValue[]; }' is not assignable to type 'TimestampStyles'. */}
				<Timestamp value={date} extraStyles={TimestampStyles} tooltipPosition="right" />
			</TextSpan>
		</Flex>
	);
};

const MetaDateMemo = memo((props: Props) => {
	const { text, date, testId } = props;
	if (date === undefined || date === null) {
		return null;
	}
	return (
		<Flex testId={testId} xcss={containerStyles}>
			<TextSpan>
				{text}
				&nbsp;
				{/* @ts-expect-error - TS2322 - Type '{ readonly whenDisplaySettingSwitchable: InterpolationValue[]; }' is not assignable to type 'TimestampStyles'. */}
				<Timestamp value={date} extraStyles={TimestampStyles} tooltipPosition="right" />
			</TextSpan>
		</Flex>
	);
});

const MetaDate: React.FC<Props> = componentWithFG(
	'issue_view_timestamp_perf',
	MetaDateMemo,
	MetaDateOld,
);

export default MetaDate;

const containerStyles = xcss({
	marginTop: 'space.050',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const TextSpan = styled.small({
	color: token('color.text.subtle'),
	paddingTop: token('space.025'),
	whiteSpace: 'nowrap',
	marginTop: 0,
	font: token('font.body.UNSAFE_small'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
	lineHeight: 8 / 6,
});

TextSpan.displayName = 'TextSpan';

const TimestampStyles: {
	readonly whenDisplaySettingSwitchable: InterpolationValue[];
} = {
	whenDisplaySettingSwitchable: css({
		'&:hover': {
			color: token('color.text.subtle'),
		},
	}),
} as const;
